// extracted by mini-css-extract-plugin
module.exports = {"dndUploader":"DndUploader_dndUploader__1F7ds","dragging":"DndUploader_dragging__1HyAZ","row":"DndUploader_row__33In7","link":"DndUploader_link__3D-tK"};